// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__CQf0c","showModal":"Modal_showModal__Ublb7","outer":"Modal_outer__EKCrp","close":"Modal_close__zm0lP","product":"Modal_product__6e+Zv"};